import { useSelector } from 'react-redux'

import { storyPaths } from './storyPaths.js'
import StoryConversation from './storyPath/StoryConversation.js'
import { selectIsOpeningSceneComplete } from './opening_scene/openingSceneSlice.js'

export default function Conversations () {
  const isOpeningSceneComplete = useSelector(selectIsOpeningSceneComplete)
  return (
    isOpeningSceneComplete && <>
      {storyPaths.filter(({ hasConversation }) => hasConversation).map(({ key, slice }) => (
        <StoryConversation key={key} slice={slice} />
      ))}
    </>
  )
}
